module.exports = __webpack_public_path__ + "img/vip_plan_banner.edb384f8.webp";